<script setup>
import {computed} from "vue";
import {
  CHART_MAX_VALUE,
  CHART_MIN_VALUE,
  VIEWBOX_CENTER,
  VIEWBOX_SIZE
} from "@/components/seo-score/visibility-chart/composables/radialChart";
import LabelText from "@/components/seo-score/visibility-chart/partials/LabelText.vue";
import ScoreText from "@/components/seo-score/visibility-chart/partials/ScoreText.vue";
import PercentagePill from "@/components/seo-score/visibility-chart/partials/PercentagePill.vue";
import TextPill from "@/components/seo-score/visibility-chart/partials/TextPill.vue";
import {POST_ANIMATION_FADE_IN_DURATION_MS, startPostAnimationEffects} from './../composables/animation';

const props = defineProps({
  currentValue: {
    type: Number,
    required: true,
  },
  finalValue: {
    type: Number,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  percentageChange: {
    type: [Number, null],
    required: true,
  },
});

const displayValue = computed(() => Math.round(
  Math.min(CHART_MAX_VALUE, Math.max(CHART_MIN_VALUE, props.currentValue))
));

const finalDisplayValue = computed(() => Math.round(
  Math.min(CHART_MAX_VALUE, Math.max(CHART_MIN_VALUE, props.finalValue))
));

// We're only going to show the percentage change if it's greater than 0.05% as it will be rounded to 0.1% in the display.
const showPercentageChange = computed(() => props.percentageChange !== null && props.percentageChange >= 0.0005);
</script>

<template>
  <g :transform="`translate(${VIEWBOX_CENTER}, ${VIEWBOX_CENTER + -(VIEWBOX_SIZE * 0.15)})`">
    <ScoreText :display-value="displayValue" />

    <LabelText :label="label" />

    <g
      :transform="`translate(0, ${VIEWBOX_SIZE * 0.02})`"
      :style="{
        opacity: startPostAnimationEffects ? 1 : 0,
        transition: `opacity ${POST_ANIMATION_FADE_IN_DURATION_MS}ms ease`,
      }"
    >
      <TextPill
        :score="finalDisplayValue"
        :align-center="!showPercentageChange"
      />

      <PercentagePill
        v-if="showPercentageChange"
        :percentage-change="percentageChange"
      />
    </g>
  </g>
</template>
